import {OverlayRef} from "@angular/cdk/overlay";

export class ToasterRef {

	constructor(private overlayRef: OverlayRef) {
	}

	public detach(): void {
		this.overlayRef.detach();
	}
}